<template>
 <app-layout>  
     <template v-slot:headerTitle>
         <p class="text-black">Integrate</p>
    </template>
     <template v-slot:tallystatus>
          <div  v-show="tally_open_status=='false'">
                <i class="fa fa-times refresh" aria-hidden="true" ></i>
          </div>
           <div  v-show="tally_open_status=='true'">
                <i class="fas fa-check refresh" aria-hidden="true" ></i>
          </div>
     </template>
    <template v-slot:headerNav>
                <!-- <jet-nav-link
                    :href="route('integrate.index')"
                    :active="route().current('integrate.index')"
                >
                    Integrate
                </jet-nav-link> -->
                <jet-nav-link
                class="ml-12"
                    :href="route('template.index')"
                    :active="route().current('template.index')"
                >
                    Template
                </jet-nav-link>
                <jet-nav-link
                class="ml-12"
                    :href="route('configurations.index')"
                    :active="route().current('configurations.index')"
                >
                    Settings
                </jet-nav-link>
        </template>
<div class="color">
     <div class="row justify-center">
            <div class=" col-8 text-center p-0 mt-3 w-80 mb-1">
                <form id="msform">
                    <ul id="progressbar" class="d-flex justify-center">
                        <li class="active" id="select"><strong>Select Data</strong></li>
                        <li id="verify"><strong>Verify Master</strong></li>
                        <li id="import"><strong>Import</strong></li>
                    </ul>
                    <br>
                 <!-- yha se form work start -->
                    <fieldset class="first_step">
                        <!-- <div class="grid grid-cols-8 text-center"> -->
                        <div class="form-card pallete-green text-left w-80 " >
                             <!-- <div></div>
                             <div> -->
                            <!-- <div class="form-group mt-10">
                                <h6>
                                    <span class="voucher-heading ">Type:</span>
                                </h6>
                                <select name="type" id="type"
                                    style="border: 1px solid #CECECE; width: 300px; height: 30px; "
                                    class="voucher-select ">
                                    <option value="">-NA-</option>
                                    <option value="Voucher">voucher</option>
                                    <option value="Master">master</option>
                                </select>
                            </div> -->
                            <!-- devex start -->
                          
                
                    <DxForm :form-data="form_data"
                             @field-data-changed="fetchTemplateName" :label-location="labelLocation">
                        <DxGroupItem
                            :col-count="1"
                            css-class="second-group"
                            >
                            <DxGroupItem>
                            <DxSimpleItem
                                :editor-options="stateOptions"
                                data-field="type"
                                editor-type="dxSelectBox"
                            />
                            <DxSimpleItem
                                :editor-options="subOptions"
                                data-field="subtype"
                                editor-type="dxSelectBox"
                            />
                             <DxSimpleItem
                                :editor-options="companyOptions"
                                data-field="company_name"
                                editor-type="dxSelectBox"
                            />
                            <DxSimpleItem
                                :editor-options="template_Options"
                                data-field="template_name"
                                editor-type="dxSelectBox"
                            />
                        </DxGroupItem>
                    </DxGroupItem>    
                    </DxForm>
                
               

                 <!-- File Uploader  start from here-->
                   <div class="widget-container flex-box">
                    <span>Upload File:</span>
                    <div
                    id="dropzone-external"
                    class="flex-box"
                    :class="[isDropZoneActive
                        ? 'dx-theme-accent-as-border-color dropzone-active'
                        : 'dx-theme-border-color']"
                    >
                    <img
                        id="dropzone-image"
                        :src="imageSource"
                        v-if="imageSource"
                        alt=""
                    >
                    <div
                        id="dropzone-text"
                        class="flex-box"
                        v-if="textVisible"
                    >
                        <span>Drag & Drop or Upload the desired Excel file here</span>
                    </div>
                    <div
                        id="dropzone-text"
                        class="flex-box"
                        v-if="uploaded_text_Visible"
                    >
                        <span >{{uploaded_text}}</span>
                    </div>
                    <DxProgressBar
                        id="upload-progress"
                        :min="0"
                        :max="100"
                        width="30%"
                        :show-status="false"
                        :visible="progressVisible"
                        :value="progressValue"
                    />
                    </div>
                    <DxFileUploader
                        id="file-uploader"
                        dialog-trigger="#dropzone-external"
                        drop-zone="#dropzone-external"
                        accept="xlsx/*"
                        :multiple="false"
                        upload-mode="instantly"
                        upload-url="https://js.devexpress.com/Demos/NetCore/FileUploader/Upload"
                        :visible="false"
                        @drop-zone-enter="onDropZoneEnter"
                        @drop-zone-leave="onDropZoneLeave"
                        @uploaded="onUploaded"
                        @progress="onProgress"
                        @upload-started="onUploadStarted"
                        @value-changed="handleFileUpload($event)"
                    />
                </div>
                            <!-- devex end -->
                            <!-- <div class=" form-group  " id="Voucher"  >
                                <h6 >
                                  <span  class="voucher-heading ">Sub-type:</span>
                                </h6> 
                                  <select name="subtype" style="border: 1px solid #CECECE; width: 300px; height: 30px;" class="voucher-select subtype">
                                      <option value="">-NA-</option>
                                      <option value="Sales">Sales</option>
                                      <option value="Purchase">Purchase</option>
                                      <option value="Recieve">recieve</option>
                                      <option value="Payment">Payment</option>
                                      <option value="CreditNote">Credit Note</option>
                                      <option value="DebitNote">Debit Note</option>
                                  </select>
                              </div> -->
                              <!-- <div class=" form-group" id="Master" style="display:none;">
                                <h6 >
                                  <span  class="voucher-heading ">Sub-type:</span>
                                </h6> 
                                   <select name="subtype" style="border: 1px solid #CECECE; width: 300px; height: 30px;" class="voucher-select subtype ">
                                        <option value="">-NA-</option>
                                        <option value="StockGroup">Stock group</option>
                                        <option value="Ledger">Ledger</option>
                                        <option value="Group">Group</option>
                                        <option value="StockItem">Stock Item</option>
                                        <option value="Godown">Godown</option>
                                        <option value="Unit">Unit</option>
                                    </select>
                              </div> -->
                              <!-- <div class=" form-group mt-0">
                                <h6 class="">
                                    <span class="voucher-heading">Company:</span>
                                </h6>
                                <select name="company" id="company"  style="border: 1px solid #CECECE ; width: 300px; height: 30px; " class="voucher-select company_name ">
                                    <option value="">-NA-</option>
                                </select>
                            </div> -->
                            <!-- <div class=" form-group mt-0" >
                                <h6 class="">
                                    <span class="voucher-heading"> Template Name:</span>
                                </h6>
                                <select id="Name" name="name" class= " voucher-select template_name" style="border: 1px solid #CECECE; width: 300px ;height: 30px;">
                                </select>
                            </div> -->
                           <!-- <div class=" form-group mt-0 " >
                               <h6 class="">
                                <span class="voucher-heading">Select File:</span> 
                               </h6>
                                <input type="file" class="file_upload " name="file" ref="file" id="customFile" style="width: 300px;height: 32px; background-color:white" v-on:change="handleFileUpload($event)">
                            </div> -->
                             <!-- </div>
                              <div></div> -->
                        </div>
                        <!-- </div> -->
                        <input type="button" @click="viewExcelData" name="next" class=" action-button-previous px-11" value="View Data" />
                        <input type="button" name="next" class="next action-button" value="Next" @click="firstFormAction"/>
                    </fieldset>
                    <!-- second step start -->
                    <!-- <fieldset>
                        <h1>scssd</h1>
                    </fieldset> -->
                    <!-- third step start -->
                    <fieldset>
                        <div class="form-card1">
                            <div class="Related">
                                Related Missing Masters
                            </div>
                        <div class="grid grid-cols-3 gap-6 pad">
                        <div class="text-center">
                            <div class="text-center" id="ledger_details" style="font-size:35px; font-weight: 600;cursor:pointer;" @click="view_details($event)">{{ledgername_count}}</div>
                        </div>
                        <div class="text-center">
                            <div id="stock_details" style="font-size: 35px;font-weight: 600; cursor:pointer;" @click="view_details($event)">{{stockitem_count}}</div>
                        </div>
                        <div class="text-center">
                            <div id="voucher_details" style="font-size: 35px; font-weight: 600;cursor:pointer;" @click="view_details($event)">{{voucher_count}}</div>
                        </div>
                        </div> 
                       
                        <div class="grid grid-cols-3 gap-6 pad1">
                            <div class=" xl:text-center sm:text-center">
                                    <span class="font">Ledgers</span>
                                </div>
                                <div class=" xl:text-center sm:text-center">
                                    <span class="font">StockItems</span>
                                </div>
                                <div class=" xl:text-center sm:text-center">
                                    <span class="font">Voucher-Type</span>
                                </div>
                            </div>
                        </div>
                        <input type="button" name="previous" class="previous action-button-previous " value="Back" />
                        <input type="button" name="next" class="next action-button " value="Next" /> 
                    </fieldset>
                    <!-- fourth step start -->
                    <fieldset>
                        <div class="form-card">
                            <div class=" import text-center">
                                <div  style="font-size: 45px; font-weight: 600;" >{{count}}</div>
                                   <span  style="font-size: 20px; font-weight: bold;">TOTAL</span>
                               </div> 
                           <div class="grid xl:grid-cols-7 sm:grid-cols-2  lg:grid-cols-5  md:grid-cols-4 gap-4 pt-5 pb-4">
                            <div class="text-center border-2 border-green-500 rounded-lg">
                             <div  style="font-size: 35px; font-weight: 600; padding-bottom: 10px;" >{{created}}</div>
                             <span class="font" >CREATED</span>
                            </div>
                            <div class="text-center border-2 border-green-500 rounded-lg">
                                 <div  style="font-size: 35px; font-weight: 600; padding-bottom: 10px;" >{{ALTERED}}</div>
                                  <span class="font">ALTERED</span>
                            </div>
                             <div class="text-center border-2 border-green-500 rounded-lg">
                                 <div  style="font-size: 35px; font-weight: 600; padding-bottom: 10px;" >{{DELETED}}</div>
                                  <span class="font">DELETED</span>
                             </div>
                             <div class="text-center border-2 border-green-500 rounded-lg">
                                  <div  style="font-size: 35px; font-weight: 600; padding-bottom: 10px;" >{{COMBINED}}</div>
                                   <span class="font">COMBINED</span>
                             </div>
                             <div class="text-center border-2 border-green-500 rounded-lg">
                                  <div  style="font-size: 35px; font-weight: 600; padding-bottom: 10px;" >{{IGNORED}}</div>
                                   <span class="font">IGNORED</span>
                             </div>
                             <div class="text-center border-2 border-green-500 rounded-lg">
                                 <div  style="font-size: 35px; font-weight: 600; padding-bottom: 10px;" >{{ERRORS}}</div>
                                 <span class="font">ERRORS</span>
                             </div>
                            <div class="text-center border-2 border-green-500 rounded-lg">
                                <div  style="font-size: 35px; font-weight: 600; padding-bottom: 10px;" >{{CANCELLED}}</div>
                                <span class="font">CANCELLED</span>
                            </div>
                            </div>
                                <!-- <input type="file" name="pic" accept="image/*"> -->
                        </div> 
                        <input
                        type="button" name="previous" class="back previous action-button-previous" value="Back" />
                        <!-- <button type="submit" class="next action-button  " ng-click="getJsonTemplateData()">Fetch</button>   -->
                        <input type="button"  class=" import action-button "   @click="thirdFormAction" value="Import" />
                        <div class="ml-96">
                            <!-- <jet-nav-link @click="integrate" class=" finish action-button-previous no-underline" style="display:none">
                              <h6 class="no-underline">Finish </h6> 
                            </jet-nav-link> -->
                             <input type="button"  @click="integrate" class=" finish action-button-previous " style="display:none;" value="Finish" />
                        </div>
                    </fieldset>
                    <!-- fieldsets -->
                    <!-- popup -->
                    <div v-show="isModalVisible">
                        <Modal
                        @close="closeModal"
                        :missing_data_var="missing_data_var"
                        ref="setDataInExcel"
                        >
                        <template v-slot:body>
                               <div id="x-spreadsheet-demo"></div>
                        </template>
                        </Modal>
                    </div>
                    <!-- popup ends -->
                        <!-- ExcelDatapopup -->
                    <div v-show="isDataViewModalVisible">
                        <ExcelDataView
                            @updateExcelData="updateExcelData"
                            @close="closeExcelModal"
                            :missing_data_var="missing_data_var"
                            ref="setExcelDataInGrid"
                        >
                        <template v-slot:excelbody>
                               <DxDataGrid
                                    :data-source="dataSource"
                                    :columns="columns"
                                    :show-borders="true"
                                    :column-min-width="100"
                                    @saving="onSaving"
                                    :selected-row-keys="selectedItemKeys"
                                >
                                <DxPaging :page-size="5"/>
                                <DxPager
                                    :visible="true"
                                    :allowed-page-sizes="pageSizes"
                                    :display-mode="displayMode"
                                    :show-page-size-selector="showPageSizeSelector"
                                    :show-info="showInfo"
                                    :show-navigation-buttons="showNavButtons"
                                />
                                <DxEditing
                                    :allow-updating="true"
                                    :allow-adding="true"
                                    :allow-deleting="true"
                                    :select-text-on-edit-start="selectTextOnEditStart"
                                    :start-edit-action="startEditAction"
                                    mode="batch"
                                />
                                 <DxScrolling column-rendering-mode="virtual"/><!-- or 'horizontal' | 'vertical' -->
                                    <!-- Here goes long content -->
                                </DxDataGrid>
                               <!-- <div id="x-spreadsheet-demo-grid"></div> -->
                        </template>
                        </ExcelDataView>
                    </div>
                    <!-- ExcelDatapopup ends -->
                </form>
                <DxToast
                    v-model:visible="isVisible"
                    v-model:message="input_filling_check"
                    v-model:type="type"
                />
            </div>
        </div>
        </div>
    </app-layout>
</template>
<script>
import 'devextreme/dist/css/dx.light.css';
import JetNavLink from '@/Jetstream/NavLink.vue';
import JetResponsiveNavLink from '@/Jetstream/ResponsiveNavLink.vue';
import AppLayout from '@/Layouts/tallyClinicAppLayout.vue';
import {DxDataGrid,DxEditing,DxScrolling,DxPaging,DxPager} from 'devextreme-vue/data-grid';
// devextreme import
import {
    DxForm,
    DxSimpleItem,
    DxGroupItem,
    DxLabel,
    DxRequiredRule,
  
} from 'devextreme-vue/form';
//import { employee, positions, states } from './data.js';
//devextreme import end
import axios from 'axios';   
import { DxToast } from 'devextreme-vue/toast';
import {getTemplateName,getJsonTemplatePhp,verifyMaster,voucher_data_render,getCompanyNames_db} from '../Utils/js/import/import_tally.js';
import {getExcelSheet} from '../Utils/js/import/master_creation.js';
import {getExcelSheetDataView} from '../Utils/js/import/excel_data_view.js';
import Modal from '../CreateTemplates/MissingMastersPopup/modal_popup.vue';
import ExcelDataView from '../CreateTemplates/MissingMastersPopup/excel_dataview_popup.vue';
import { DxFileUploader } from 'devextreme-vue/file-uploader';
import { DxProgressBar } from 'devextreme-vue/progress-bar';
import {isElectron,checkTallyIsOpenElectron} from '../Utils/js/utils/utils.js';
var is_tally_open = "";
export default {
    components:{
        Modal,
        AppLayout,
        DxForm,
        DxFileUploader,
        DxProgressBar,
        DxGroupItem,
        DxSimpleItem,
        DxLabel,
        JetResponsiveNavLink,
        JetNavLink,
        DxToast,
        DxRequiredRule,
        ExcelDataView,
        DxDataGrid,
        DxEditing,
        DxScrolling,
        DxPaging,
        DxPager
    },
    computed:{
       
    },
    data: function(){
        return{
        count:0,
        displayMode: 'full',
        pageSizes: [5, 10, 'all'],
        showPageSizeSelector: true,
        showInfo: true,
        showNavButtons: true,
        selectTextOnEditStart: true,
        startEditAction: 'click',
        tally_open_status:'',
        dataSource:[],
        isDataViewModalVisible:false,
        isVisible:false,
        input_filling_check:"",
        uploaded_text_Visible:false,
        uploaded_text:"",
        type: 'info',
        isDropZoneActive: false,
        imageSource: '',
        textVisible: true,
        progressVisible: false,
        progressValue: 0,
        allowedFileExtensions: ['.jpg', '.jpeg', '.gif', '.png','.xlsx'],
        labelLocation:'top',
        template_data:[],
        template_data_php:[],
        file:'',
        Exceldata_verify:[],
        Exceldata:[],
        ledgername:[],
        stockitem:[],
        ledgername_ver:[],
        stockitem_ver:[],
        voucher_ver:[],
        ledgername_count:0,
        stockitem_count:0,
        voucher_count:0,
        isModalVisible: false,
        missing_data_var:[],
        data:[],
        obj_view:'',
        vch_type:'',
        voucher_create:[],
        cr_value:0,
        dr_value:0,
        meta:'',
        count : 0,
        created :0,
        ALTERED : 0,
        CANCELLED :0,
        COMBINED : 0,
        DELETED : 0,
        ERRORS : 0,
        IGNORED : 0,
        LASTMID : 0,
        LASTVCHID : 0,
        stateOptions: {
            items: [{Show:'-NA-',Value:''},{Show:'voucher',Value:'Voucher'},{Show:'master',Value:'Master'}],
            valueExpr: "Value",
            displayExpr: "Show"
        },
        subOptions:{
            items: [{Show:'-NA-',Value:''},{Show:'Sales',Value:'Sales'},{Show:'Purchase',Value:'Purchase'},{Show:'receive',Value:'Receive'},{Show:'Payment',Value:'Payment'},{Show:'Credit Note',Value:'CreditNote'}, {Show:'Debit Note',Value:'DebitNote'}],
            valueExpr: "Value",
            displayExpr: "Show"
        },
        companyOptions:{
            items: [],
        },
        template_Options:{
            items:[],
        },
        form_data:{"type":"","subtype":"","company_name":"","template_name":""},
        }
    },
    methods:{
         integrate(){
              this.$inertia.post(route('/integrate'));
          },
         customizeColumns(columns) {
          columns[0].width = 70;
        },
        isCompactMode() {
          return this.displayMode === 'compact';
        },
        handleFileUpload(e){
            this.file = e.value;
        },
        firstFormAction(){
            var _this=this;
            var template_name = this.form_data.template_name;
            var template_params = this.template_data_php[template_name];
            var datasource = this.dataSource;
            if(this.form_data.type&&this.form_data.subtype&&this.form_data.company_name&&this.form_data.template_name&&this.file[0]){
                getJsonTemplatePhp(_this,template_params,this.meta,datasource);
            }
        },
        thirdFormAction(){
            var _this = this;
            voucher_data_render(_this.template_data,_this.obj_view,_this.vch_type,_this,this.meta);
        },
        view_details(e){
            this.isModalVisible = true;
            if (e.target.attributes.id.value == 'ledger_details') {
                var _this=this;
                var refs = this.$refs.setDataInExcel;
                getExcelSheet(_this,_this.ledgername_ver,refs,'ledger_details');
            }
            else if (e.target.attributes.id.value == 'stock_details') {
                var _this=this;
                var refs = this.$refs.setDataInExcel;
                getExcelSheet(_this,_this.stockitem_ver,refs,'stock_details');
            }
            else {
            }
        },
        showModal() {
            this.isModalVisible = true;
        },
        closeModal() {
            var _this=this;
            this.isModalVisible = false;
            verifyMaster(_this)
        },
        closeExcelModal(){
             this.isDataViewModalVisible = false;
        },
        getCookie(name){
            const value = `; ${document.cookie}`;
            return value.split(";")[1].split("=")[1];
        },
        onDropZoneEnter(e){
            if (e.dropZoneElement.id === 'dropzone-external') {
                this.isDropZoneActive = true;
            }
        },
        onDropZoneLeave(e){
            if (e.dropZoneElement.id === 'dropzone-external') {
                this.isDropZoneActive = false;
            }
        },
        viewExcelData(e){
            var _this = this;
            getExcelSheetDataView(_this,this.file[0]);
            this.isDataViewModalVisible = true;
        },
        onUploaded(e){
            const { file } = e;
            const fileReader = new FileReader();
            fileReader.onload = () => {
                this.isDropZoneActive = false;
                this.imageSource = fileReader.result;
            };
            fileReader.readAsDataURL(file);
            this.textVisible =false;
            this.progressVisible = false;
            this.uploaded_text_Visible=true;
            this.uploaded_text=e.file.name;
            this.progressValue = 0;
            var _this = this;
            getExcelSheetDataView(_this,this.file[0]);
        },
        onProgress(e) {
            this.progressValue = (e.bytesLoaded / e.bytesTotal) * 100;
        },
        onUploadStarted() {
            this.imageSource = '';
            this.progressVisible = true;
        },
        fetchTemplateName(e){
            var params = this.form_data;
            var _this = this;
            getTemplateName(_this,params);
        },
        checkTallyStatus(){
            var _this = this;
            checkTallyIsOpenElectron(_this);
        },
        onSaving(e){
            console.log(this.dataSource);
        }
    },
    mounted(){
        this.meta=this.getCookie();
        var _this = this;
        //check if tally is open 
        if(isElectron()){
            this.meta = "electron";
            window.api.send('checkTallyOpening'); 
            window.api.receive("checkTallyOpening-reply", (tally_response) => {
                if(tally_response == "tally is not open"){
                    this.tally_is_open = false;
                     this.tally_open_status = "false";
                }
                else if(tally_response == "tally is open"){
                    this.tally_is_open = true;
                    this.tally_open_status = "true";
                    console.log(tally_response);
                    getCompanyNames_db(_this);
                }
            });
        }
        else{
            axios.post('/checkTallyIsOpen')
            .then((result) => {
                if(result.data!="not_open"){
                    getCompanyNames_db(_this);
                }
            })
        }

        var current_fs, next_fs, previous_fs; //fieldsets
        var opacity;
        var current = 1;
        var steps = $("fieldset").length;
        var template_data=[];

        setProgressBar(current);

        $(".next").click(function () {
            current_fs = $(this).parent();
            next_fs = $(this).parent().next();
            //Add Class Active
                        $("#progressbar li").eq($("fieldset").index(next_fs)).addClass("active");

                        //show the next fieldset
                        next_fs.show();
                        //hide the current fieldset with style
                        current_fs.animate({ opacity: 0 }, {
                            step: function (now) {
                                // for making fielset appear animation
                                opacity = 1 - now;
                                current_fs.css({
                                    'display': 'none',
                                    'position': 'relative'
                                });
                                next_fs.css({ 'opacity': opacity });
                            },
                            duration: 500
                        });
                        setProgressBar(++current);
        });

        $(".previous").click(function () {

            current_fs = $(this).parent();
            previous_fs = $(this).parent().prev();
            //Remove class active
            $("#progressbar li").eq($("fieldset").index(current_fs)).removeClass("active");
            //show the previous fieldset
            previous_fs.show();
            //hide the current fieldset with style
            current_fs.animate({ opacity: 0 }, {
                step: function (now) {
                    // for making fielset appear animation
                    opacity = 1 - now;
                    current_fs.css({
                        'display': 'none',
                        'position': 'relative'
                    });
                    previous_fs.css({ 'opacity': opacity });
                },
                duration: 500
            });
            setProgressBar(--current);
        });

        function setProgressBar(curStep) {
            var percent = parseFloat(100 / steps) * curStep;
            percent = percent.toFixed();
                $(".progress-bar")
                    .css("width", percent + "%")
            }
            $(".submit").click(function () {
                return false;
            })
            $('#type').on('change', function () {
                $("#Name").find('option').remove();
                $("select[name='subtype']").val([]);

                if ($(this).val() == "Voucher") {
                    $('#Voucher').css('display', 'block');
                    $('#Master').css('display', 'none');
                }
                else {
                    $('#Voucher').css('display', 'none');
                    $('#Master').css('display', 'block');
                };
            })

            $('.subtype').on('change', function () {
           
                var _this = this;
                $("#Name").find('option').remove();
                var formData = $('#form').serializeArray();
                template_data = [];
            
                $.each(formData, function (key,value) {
                    if (value.value != '') {
                        template_data[value.name] = value.value;
                    }
                })
                template_data['subtype'] = $(this).val();
                template_data['type'] = $('#type').val();
                $('#Name').val("<option value=" + $(this).val() + ">" + $(this).val() + "</value>");
                var params = {type:template_data['type'],subtype:template_data['subtype']}
               
                axios.post('fetchTemplateNames',params)
                    .then((result)=>{
                        var templates = [];
                        templates =result.data;
                        if (templates.length == 0) {
                            $("#Name").find('option').remove();
                        }
                        else {
                            $.each(templates, function (key, value) {
                                if (value.length > 0) {
                                    $("#Name").find('option').remove();
                                }
                            })
                            $.each(templates, function (key, value) {
                                if (value.length > 0) {
                                    this.tempOptions.items.push(value);
                                }
                            })
                        }
                })
            })
    },
    created:function(){
         
    }
}
</script>

<style >

.color{
    background-color: rgb(156, 203, 169);
    height:85vh;
    background-size: cover;
    overflow: hidden;
    /* padding-bottom: 20px; */
}

/* .file_upload[type='file'] {
            color: #77DD77;
            font-size: 12px;
            border: 1px solid #77DD77;
        }
        .file_upload[type=file]::file-selector-button {
            border: 0px solid #77DD77;
            color: #FFFFFF;
            padding: 2px;
            font-weight: 400;
            font-size: 14px;
            border-radius: 0px !important;
            background-color: #77DD77;
        } */
      .main-content {
        background-color: #f3f4f6;
            /* width: calc(100% - 250px); */
            /* height: 100vh; */
            margin-left: 212px;
            padding-bottom: 2px;
        } 
    * {
        margin: 0;
        padding: 0
    }

    html {
        height: 100%
    }

    p {
        color: grey
    }
    .pad{
        padding-top: 35px;
    }
    .pad1{
        padding-top: 35px;
        padding-bottom: 35px;
    }

    #msform {
        text-align: center;
        position: relative;
        margin-top: 20px
    }

    #msform fieldset {
        border: 0 none;
        border-radius: 0.5rem;
        box-sizing: border-box;
        width: 100%;
        margin: 0;
        padding-bottom: 20px;
        position: relative
    }

    .form-card {
        /* text-align:left; */
        margin-left: auto;
        margin-right: auto;
    }

    #msform fieldset:not(:first-of-type) {
        display: none
    }

    #msform input,
    #msform textarea {
        /* padding: 8px 15px 8px 15px; */
        /* border: 1px solid #ccc; */
        border-radius: 0px;
        /* margin-bottom: 25px;
        margin-top: 2px; */
        width: 100%;
        box-sizing: border-box;
        font-family: montserrat;
        color: #2C3E50;
        /* background-color: #ECEFF1; */
        font-size: 16px;
        letter-spacing: 1px
    }

    #msform input:focus,
    #msform textarea:focus {
        -moz-box-shadow: none !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        border: 1px solid #F5F591;
        outline-width: 0
    }

    #msform .action-button {
        width: 100px;
        background: #F5F591;
        font-weight: 600;
        color: #000000;
        border: 0 none;
        border-radius: 0px;
        cursor: pointer;
        /* padding:3px 1px; */
        padding: 7px 1px;
        margin: 20px 0px 20px 5px;
        border-radius: 10px;
        /* float: right */
        text-align: center;
    }

    #msform .action-button:hover,
    #msform .action-button:focus {
        background-color: #F5F591;
    }

    #msform .action-button-previous {
        width: 100px;
        background: #616161;
        font-weight: 600;
        color: white;
        border: 0 none;
        border-radius: 10px;
        cursor: pointer;
        /* padding:4px 20px; */
        padding: 7px 1px;
        margin: 20px 0px 20px 0px;
        /* float: left; */
        text-align: center;
    }

    #msform .action-button-previous:hover,
    #msform .action-button-previous:focus {
        background-color: #000000
    }

    .card {
        z-index: 0;
        border: none;
        position: relative
    }

    .steps {
        font-size: 25px;
        color: gray;
        margin-bottom: 10px;
        font-weight: normal;
        text-align: right
    }

    .fieldlabels {
        color: gray;
        text-align: left
    }

    #progressbar {
        margin-bottom: 30px;
        overflow: hidden;
        color: lightgrey
    }

    #progressbar .active {
        color: #000000
    }

    /*  */

    #progressbar li {
        list-style-type: none;
        font-size: 15px;
        width: 25%;
        float: left;
        position: relative;
        font-weight: 400
    }

    #progressbar #select:before {
        content: "1";
        /*--You can add font icon code here--*/
        font-family: FontAwesome;
        /* color: #000000; */
      
    }
    #progressbar #verify:before {
        font-family: FontAwesome;
        content: "2";
       
    }
    #progressbar #import:before {
        font-family: FontAwesome;
        content: "3";
        

    }
    #progressbar li:before {
        width: 50px;
        height: 50px;
        line-height: 45px;
        display: block;
        font-size: 20px;
        color: #ffffff;
        background: lightgray;
        border-radius: 50%;
        margin: 0 auto 10px auto;
        padding: 2px;
        /* z-index: -1; */
    }
    #progressbar li:after {
        content: '';
        width: 100%;
        height: 2px;
        text-align: center;
        margin-left: auto;
        margin-right: auto;
        background: lightgray;
        position: absolute;
        left: 0;
        top: 25px;
        /* z-index: 1 */
    }
    #progressbar li.active:before,
    #progressbar li.active:after {
        background: #FDFD96;
        color:black;
      
        
    }
    #progressbar li #verify:before{
        background: #FDFD96;
        color:black;
        
    }
    #progressbar li #important:before{
        background: #FDFD96;
        color:black;
         
    }
    .fit-image {
        width: 100%;
        object-fit: cover
}
    .progress-style {
        margin-right: auto;
        margin-left: auto;
    }
    .pallete-green{
        background-color:rgb(156, 203, 169) ;
    }
      
 .auto-margin{
    margin-left: auto;
    margin-right: auto;
 }  

 .Related {
        margin-top: 50px;
        font-size: 22px;
        font-weight: 600;
        text-align: center;
    }
    .container{
          text-align: center;
           
        }
        /* upload image devex */
        #dropzone-external {
  width: 320px;
  height: 70px;
  background-color: rgba(183, 183, 183, 0.1);
  border-width: 2px;
  border-style: dashed;
  padding: 10px;
}

#dropzone-external > * {
  pointer-events: none;
}

#dropzone-external.dropzone-active {
  border-style: solid;
}

.widget-container > span {
  font-size: 14px;
  /* font-weight: bold; */
  margin-bottom: 5px;
  margin-top: 7px;
  margin-right: 240px;
}

#dropzone-image {
  max-width: 70%;
  max-height: 70%;
}

#dropzone-text > span {
  font-weight: 100;
  opacity: 0.5;
}

#upload-progress {
  display: flex;
  margin-top: 10px;
}

.flex-box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
} 

 /* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  #dropzone-external {
  /* width: 230px; */
}   
}

</style>

